var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBarcode = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 436.3 248.67",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.66,
    y: 40.81,
    width: 10.8,
    height: 167.04
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.45 17.49 75.45 0 19.96 0 0 0 0 17.49 0 231.18 0 248.67 19.96 248.67 75.45 248.67 75.45 231.18 19.96 231.18 19.96 17.49 75.45 17.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.85 231.18 360.85 248.67 416.34 248.67 436.3 248.67 436.3 231.18 436.3 17.49 436.3 0 416.34 0 360.85 0 360.85 17.49 416.34 17.49 416.34 231.18 360.85 231.18"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.58,
    y: 40.81,
    width: 5.28,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.7,
    y: 40.81,
    width: 5.28,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.22,
    y: 40.81,
    width: 5.28,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.82,
    y: 40.81,
    width: 5.28,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.34,
    y: 40.81,
    width: 5.28,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.22,
    y: 40.81,
    width: 5.28,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.58,
    y: 40.81,
    width: 5.28,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.42,
    y: 40.81,
    width: 11.52,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.38,
    y: 40.81,
    width: 11.52,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.94,
    y: 40.81,
    width: 11.52,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.98,
    y: 40.81,
    width: 11.52,
    height: 167.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.54,
    y: 40.81,
    width: 15.84,
    height: 167.04
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBarcode, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/barcode.7ebfa8f1.svg";
export { ForwardRef as ReactComponent };